import humps from 'humps'

import { parseURL } from './helpers.js'

const GET = 'get'
const PUT = 'put'
const POST = 'post'
const PATCH = 'patch'
const DELETE = 'delete'
const REDIRECT = 'redirect'

// FIXME: Remove hardcoded fix and work on a more long term fix
const KEYS_TO_NOT_CAMELIZE = ['CPM', 'Hybrid', 'PercentOfMediaCost']

const returnData = (
  response,
  { transformPayload, transformOnlyResponse, transformOnlyRequest }
) => {
  const shouldTransform = (transformPayload || transformOnlyResponse) && !transformOnlyRequest

  if (shouldTransform) {
    const camelizedResponse = humps.camelizeKeys(response, (key, convert) => {
      return /^_/.test(key) || KEYS_TO_NOT_CAMELIZE.includes(key) ? key : convert(key)
    })
    return camelizedResponse
  }

  return response
}

// Decamelize keys for the API
const decamelizePayload = (data) => humps.decamelizeKeys(data)

// Check if should be decamelized or not
const parsePayload = ({ data, transformPayload, transformOnlyResponse, transformOnlyRequest }) => {
  const shouldTransform = (transformPayload || transformOnlyRequest) && !transformOnlyResponse
  return shouldTransform ? decamelizePayload(data) : data
}

const parseParams = (url, config = {}, data) => (method) => {
  const {
    removeTrailingSlash,
    transformPayload = true,
    transformOnlyRequest,
    transformOnlyResponse,
    formData,
    headers,
  } = config

  // Methods that require payload
  const payloadMethods = [PUT, POST, PATCH]

  // Methods that use query params
  const queryParamMethods = [GET, REDIRECT]

  const requestData = formData
    ? data
    : {
        ...(payloadMethods.includes(method) && {
          ...parsePayload({
            data,
            transformPayload,
            transformOnlyResponse,
            transformOnlyRequest,
          }),
        }),
        ...(queryParamMethods.includes(method) && { ...data }),
      }

  const URL = parseURL(url, removeTrailingSlash)

  // We do not want to make event-feeds request to discovery id cause it will fail
  if (URL.includes('/event-feeds/discovery')) {
    return
  }

  return new Promise((resolve, reject) => {
    window._api[method](
      parseURL(url, removeTrailingSlash),
      requestData,
      (error, response) => {
        if (error) {
          reject(error)
          return
        }

        resolve(
          returnData(response, { transformPayload, transformOnlyResponse, transformOnlyRequest })
        )
      },
      { ...(formData && { formData }), ...(headers && { headers }) }
    )
  })
}

export const get = (...params) => parseParams(...params)(GET)
export const post = (...params) => parseParams(...params)(POST)
export const put = (...params) => parseParams(...params)(PUT)
export const patch = (...params) => parseParams(...params)(PATCH)
export const del = (...params) => parseParams(...params)(DELETE)
export const redirect = (...params) => parseParams(...params)(REDIRECT)
